import { inspection } from './inspection'

const forwarder = {
  inspector_inspections: inspection,
}
export default forwarder
